import axios from 'axios';

export default {
  getCountries: () => axios.get('general/countries'),
  getStates: () => axios.get('general/states'),
  getRegimens: () => axios.get('general/regimens'),
  getUsosCfdi: () => axios.get('general/usos-cfdi'),
  getFormasPago: () => axios.get('general/formas-pago'),
  getMetodosPago: () => axios.get('general/metodos-pago'),
  getPaymentPeriods: (config = {}) => axios.get('general/payment-periods', config),
  getGlobalInvoicePeriodicities: (config = {}) => axios.get('general/global-invoice-periodicities', config),
  getUsers: (config = {}) => axios.get('general/users', config),
  getBanks: (config = {}) => axios.get('general/banks', config),
  getFinancialAccountTypes: (config = {}) => axios.get('general/financial-account-types', config),
};
